import { useGetCompaniesTypes } from '@entities/company';
import { Loader, Select, type SelectProps } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

export const CompanyTypesSelect = ({ ...props }: SelectProps) => {
  const { data: companyTypes, isLoading: isCompanyTypesLoading } =
    useGetCompaniesTypes();

  const companyTypesOptions = companyTypes?.map(({ value, title }) => ({
    value,
    label: title,
  }));

  return (
    <Select
      {...props}
      title='Форма организации'
      description='Выберите организационно-правовую форму компании'
      data={companyTypesOptions}
      searchable
      rightSection={
        isCompanyTypesLoading ? (
          <Loader size='xs' />
        ) : (
          <IconChevronDown size={20} color='var(--mantine-color-primary-7)' />
        )
      }
      disabled={isCompanyTypesLoading}
    />
  );
};
